module.exports = __webpack_public_path__ + "static/media/more.3f3c9f7e.svg";